import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import apiAmiboReducer from './Reducer/apiAmiboReducer'
import detailAmiboReducer from './Reducer/detailAmiboReducer'
import myFavoritAmiboReducer from './Reducer/myFavoritAmiboReducer'

const rootReducer = combineReducers ({
  apiAmibo: apiAmiboReducer,
  detailAmibo: detailAmiboReducer,
  myFavoritAmibo: myFavoritAmiboReducer
})

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store